import GitInfo from 'react-git-info/macro'

const PRODUCTION = 'production'
const STAGING = 'staging'
const DEVELOPMENT = 'dev'

const LOCAL_DEVELOPMENT = true
const LOCAL_DEVELOPMENT_ENVIRONMENT = STAGING

export function getVersion() {
  return `${process.env.REACT_APP_VERSION}-${GitInfo().commit.shortHash}`
}

export function getEnvironment() {
  // this environment variable is set up in the amplify console
  // see "App settings" -> "Environment variables"
  // also, see amplify.yml in the root of the project
  // In case the project is running locally (amplify console variables are not available)
  // in order to connec to the correct backend, set LOCAL_DEVELOPMENT = true
  // and set LOCAL_DEVELOPMENT_ENVIRONMENT to the appropriate environment
  if (process.env.REACT_APP_BUILD_STAGE) {
    console.log(
      '************************process.env.REACT_APP_BUILD_STAGE',
      process.env.REACT_APP_BUILD_STAGE
    )
    return process.env.REACT_APP_BUILD_STAGE
  } else if (LOCAL_DEVELOPMENT) {
    return LOCAL_DEVELOPMENT_ENVIRONMENT
  } else {
    return DEVELOPMENT
  }
}

export function isProduction() {
  return getEnvironment() === PRODUCTION
}

export function isStaging() {
  return getEnvironment() === STAGING
}

export function isDevelopment() {
  return getEnvironment() === DEVELOPMENT
}
